import BusinessIcon from "@mui/icons-material/Business";
import GroupsIcon from "@mui/icons-material/Groups";

import { Box, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function BoardTabs({ value, onChange, mitarbeiterBereich }) {
  const { t } = useTranslation();

  const handleChange = (e, newValue) => {
    onChange(newValue);
  };

  return (
    <Box
      sx={{
        borderBottom: 1,

        borderColor: "divider",

        width: "100%",
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          minHeight: 52,

          "& .MuiTabs-indicator": {
            height: 3,

            borderRadius: "3px 3px 0 0",
          },

          "& .MuiTab-root": {
            minHeight: 52,

            minWidth: {
              xs: 150,
              sm: 190,
            },

            textTransform: "none",

            fontWeight: 600,

            fontSize: {
              xs: "0.85rem",
              sm: "0.95rem",
            },

            gap: 0.5,

            transition: "0.2s",

            "&:hover": {
              backgroundColor: "action.hover",
            },
          },
        }}
      >
        <Tab value="company" label={t("Firma")} icon={<BusinessIcon fontSize="small" />} iconPosition="start" />
        {mitarbeiterBereich && <Tab value="employee" label={t("Mitarbeiter")} icon={<GroupsIcon fontSize="small" />} iconPosition="start" />}
      </Tabs>
    </Box>
  );
}
